import styled from "styled-components";
import { motion } from "framer-motion";
import { ContainerInterface, RadioButtonInterface } from "./interface";
import color from "../../assets/css/colors";

export const Fieldset = styled.fieldset``

export const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ContainerInputCity = styled.div`
  width: 57%;
`

export const ContainerInputUf = styled.div`
  width: 37%;
`

export const DivForm = styled.div`
    display: ${(p: ContainerInterface) => p.isAddFormVisible ? "flex" : "none"};
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: #B8B4CC;

    @media (max-width: 600px) {
        width: 100%;
        border: none;
    }
`
export const Legend = styled.legend`
    margin-top: 41px;
    margin-bottom: 17px;
    color: #454546;
    font-size: 13px;
`;

export const THead = styled(motion.thead)`
  background: #f2f1fa 0% 0% no-repeat padding-box;
  height: 34px;
  opacity: 1;
`;

export const Th = styled.th`
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #b8b4cc;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const ThFilterable = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #b8b4cc;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`

export const Td = styled.td`
  font-family: muli, sans-serif;
  font-weight: 300;
  font-size: normal;
  color: #172b4d;
  text-align: center;
  vertical-align: middle !important;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const RadioButtonRow = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    margin-bottom: 28px;
`;

export const RadioButtonForm = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const RadioButtonContainer = styled.div`
    display: flex;
    width: 10px;
    height: 10px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${color.primary};
    border-radius: 9px;
    margin-right: 8px;
`;

export const RadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? color.primary : "transparent"};
`;

export const RadioButtonDescription = styled.span`
    font: normal normal 300 13px Muli;
    color: #707070;
`;